export const retrieveLink = async (term) => {
    const response = await fetch(`gitPrime/link?email=${term}`);
    const model = await response.json();
    return model.user;
};

export default {
    retrieveLink
};
